export default __webpack_public_path__ + "static/banner-a67bbf6687c6ca020312629c79dddad4.svg";